
import Transformer from './../transformer'
import NotificationTransformer from './notification'
import SinisterNotificationTransformer from './sinisterNotification'

export default class NotificationSinisterTransformer extends Transformer {
  static fetch(notification) {
    let data = NotificationTransformer.fetch(notification)
    data.sinister=SinisterNotificationTransformer.fetch(notification.data.content)
    return data
  }
}


// WEBPACK FOOTER //
// ./src/transformers/notification/notificationSinister.js